import { PushNotificationRequest, PushNotificationsApi } from '@flipdish/api-client-typescript';
import { getApiEndPoint } from '../../helpers/apibase';
import { CredentialsAuth } from '../../helpers/utilities';
import { mapServerError } from '../../services/utils/serverErrorMapper';

const api = new PushNotificationsApi(getApiEndPoint());
api.setDefaultAuthentication(new CredentialsAuth());
// #region sendPushNotification

export async function sendPushNotification(appId: string, notification: PushNotificationRequest) {
  try {
    const incomingMessage = await api.schedulePushNotification(appId, notification);

    return incomingMessage.body;
  } catch (incomingMessage) {
    throw mapServerError(incomingMessage);
  }
}
// #endregion

// #region updatePushNotification

export async function updatePushNotification(
  appId: string,
  scheduledPushNotificationId: number,
  notification: PushNotificationRequest
) {
  try {
    const incomingMessage = await api.updatePushNotification(
      appId,
      scheduledPushNotificationId,
      notification
    );

    return incomingMessage.body;
  } catch (incomingMessage) {
    throw mapServerError(incomingMessage);
  }
}
// #endregion

// #region getPushNotifications

export async function getPushNotifications(appId: string, page: number, limit: number) {
  try {
    const incomingMessage = await api.getPushNotifications(appId, page, limit);

    return incomingMessage.body;
  } catch (incomingMessage) {
    throw mapServerError(incomingMessage);
  }
}
// #endregion

// #region deletePushNotification

export async function deletePushNotification(appId: string, scheduledPushNotificationId: number) {
  try {
    // @ts-ignore
    await api.deletePushNotification(appId, scheduledPushNotificationId);
  } catch (incomingMessage) {
    console.log(incomingMessage);
    throw mapServerError(incomingMessage);
  }
}
// #endregion
